export const AUTH_STORAGE_KEYS = {
  ACCESS_TOKEN: 'auth_token',
  USER_DATA: 'user_data',
  OTP_EMAIL: 'otp_email',
  OTP_EXPIRES_AT: 'otp_expires_at',
  OTP_RESEND_AVAILABLE_AT: 'otp_resend_available_at'
} as const;

export const AUTH_COOKIE_NAME = 'auth_token';

export const AUTH_ROUTES = {
  LOGIN: '/login',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password'
} as const;

export const GUEST_ROUTES = ['/login', '/forgot-password', '/reset-password'];
